const FACTS = [
  { id: 'chart', value: '1 chart', label: 'One XAUUSD M15 chart is all it needs' },
  { id: 'risk', value: '0.5–1.5%', label: 'Risk per trade, fixed by the preset' },
  { id: 'filters', value: '4 filters', label: 'Structure, momentum, volatility, news' },
  { id: 'exits', value: '6 exit rules', label: 'Stop, target, break-even, trail, partial, time' },
];

/**
 * A compact "at a glance" strip that sits directly under the page header.
 *
 * The header is text-only, so a visitor scanning the page has no quick sense
 * of what GoldWarden actually is. These four facts give them the gist in a
 * couple of seconds, before they commit to reading the sections below.
 */
export default function QuickFacts() {
  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-5 py-6 md:py-7">
          {FACTS.map((fact) => (
            <div key={fact.id} className="flex items-start gap-3">
              <span className="mt-1 w-1 h-9 rounded-full bg-accent-400 shrink-0" aria-hidden="true"></span>
              <div>
                <p className="font-heading text-lg md:text-xl font-bold text-foreground-950 leading-none">
                  {fact.value}
                </p>
                <p className="mt-1.5 text-xs leading-snug text-foreground-600">{fact.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}